//메인화면 메뉴리스트
import React, {useState, useEffect} from "react";
import IPut from 'iput';
//MUI
import {Checkbox, MenuItem, TextField, Button,Modal,Typography,Box,CircularProgress,} from '@mui/material';
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import {theme} from '../../assets/themes';
import USelectBox from "../../components/mui/USelectBox";
import UAuthButton from "../../components/mui/UAuthButton";
import UButton from "../../components/mui/UButton";
import {useLocation} from 'react-router-dom';
import {API} from "../../config";
import {fni18n} from "../../services/commonService";
import {
    getAPI, postAPI, deleteAPI,
} from "../../services/commonService";
import AuthenticationService from "../../pages/auth/AuthenticationService";

const userLoginId = AuthenticationService.getLoggedInUserID();
const date = new Date();
const now = date.toISOString().slice(0, 10);
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const MachineModify = (props) => {
    const location = useLocation();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        loadAccessKey();
        setOpen(true);
    }
    const handleClose = () => setOpen(false);
    const [loading, setLoading] = useState(false);        // 로딩바   
    const [errors, setErrors] = useState("");
    const [accessKey, setAccessKey] = useState({
        "safeId":"",
        "accessKeyId":"",
        "accessKeySecret":"",
    });
    const [branchs, setBranch] = useState([]);
    const [models, setModels] = useState([]);
    const [select, setSelect] = useState({
        storeCd: "N/A",
    });
    const [autoUnloadOpt, setAutoUnloadOpt] = useState(props.data.autoUnloadOpt || "CST");
    const [manualUnloadOpt, setManualUnloadOpt] = useState(props.data.manualUnloadOpt || "CST");

    const modify = props.data;
    const onParamsChange = props.onParamsChange;
    const onCheckboxChange = props.onCheckboxChange;
    const onIpChange = props.onIpChange;
    const onStoreChage = props.onStoreChage;
    const onRadioButtonChange = props.onRadioButtonChange;

    const Dtotal = "$" + Number(modify.cnt100D * 100 + modify.cnt50D * 50 + modify.cnt20D * 20 + modify.cnt10D * 10 + modify.cnt5D * 5 + modify.cnt1D * 1).toLocaleString('en-US');

    //화면 로드 시
    useEffect(() => {
        const getLoadData = async () => {
            try {
                await loadComboBoxBranch();
                await loadComboBoxModel();
                await loadAccessKey();
            } catch (e) {
            }
        };
        getLoadData();
    }, []);
    useEffect(() => {
        const getLoadData = async () => {
            try {
                await loadAccessKey();
            } catch (e) {
            }
        };
        getLoadData();
    }, [modify.ifYn]);

    useEffect(() => {
        let e;
        if (select.storeCd != "N/A" && modify.chkCreate == "") {
            e = {
                storeCd: {
                    name: 'storeCd',
                    value: select.storeCd,
                },
            }
        } else if (modify.chkCreate == "") {
            e = {
                storeCd: {
                    name: 'storeCd',
                    value: '',
                },
            }
        } else {
            e = {
                storeCd: {
                    name: 'storeCd',
                    value: modify.storeCd,
                },
            }
        }
        onStoreChage(e)
    }, [select]);
    // 콤보박스 데이터
    const loadComboBoxBranch = async () => {
        try {
            const res = await getAPI(API.COMMON.BRANCH, {userId: userLoginId});
            const _inputData = res.data.result.map((m) => ({
                    cd: m.storeCd,
                    name: m.storeNm,
                })
            );
            setBranch(_inputData);
            setSelect({
                ...select,
                ['storeCd']: _inputData[0].cd,
            });
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadAccessKey = async () => {
        try {
            const res = await getAPI(API.OPER.MACHINE_KEY, {safeId: modify.storeCd+modify.machineNo});
            setAccessKey(res.data);
        } catch (e) {
            console.error(e.message);
        }
    };
    const handleDelete  = async () => {
        try {
            const res = await deleteAPI(API.OPER.MACHINE_KEY, {safeId: modify.storeCd+modify.machineNo});
            modify.ifYn = 'N'
            setOpen(false);
        } catch (e) {
            console.error(e.message);
        }
    };
    const handleSave = async () => {
        try {
            const newErrors = {};
            
            for (const key in accessKey) {
                if (!accessKey[key]) {
                    alert(`${key} field is required.`)
                    setErrors(`${key} field is required.`);
                    return; 
                }
            }
            setLoading(true);
            const res = await postAPI(API.OPER.MACHINE_KEY, accessKey);
            setLoading(false); //로딩바 종료
            if(res.data.code === 200){
                modify.ifYn = 'Y'
                setOpen(false);
            } else {
                alert('Invalid ID or Key.')
            }

        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxModel = async () => {
        try {
            const res = await getAPI(API.COMMON.MODEL);
            const _inputData = res.data.result.map((m) => ({
                    cd: m.machKndCd,
                    name: m.machKndCd,
                })
            );
            setModels(_inputData);
        } catch (e) {
            console.error(e.message);
        }
    };
    // 체크박스가 클릭될 때 상태 변경
    const handleCheckboxChange = (value) => {
        setAutoUnloadOpt(value);
        // 변경된 값을 부모 컴포넌트로 전달
        if (onRadioButtonChange) {
            onRadioButtonChange({...modify, autoUnloadOpt: value});
        }
    };
    // 체크박스가 클릭될 때 상태 변경
    const handleManualCheckboxChange = (value) => {
        setManualUnloadOpt(value);
        // 변경된 값을 부모 컴포넌트로 전달
        if (onRadioButtonChange) {
            onRadioButtonChange({...modify, manualUnloadOpt: value});
        }
    };
    const onChange = (e) =>{
        const {name, value} = e.target;
        setAccessKey({
            ...accessKey,
            [name]: value,
        })

    }

    return (
        <div className="pop-container">
            {/* 상단메뉴명 */}
            <div className="header">
                {fni18n('장비 등록/수정')}
            </div>
            <div className="contents">
                <TableContainer className="table-container">
                    <Table className="table" size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                                <TableCell className="table-cell">
                                    {modify.chkCreate == "" &&
                                        <FormControl size="small" fullWidth>
                                            {/* <Select
                                    name="branch"
                                    value={modify.branch}
                                    onChange={onParamsChange}
                                >
                                    {branchs.map((map)=>(
                                        <MenuItem key={map.name} value={map.name}>
                                            {map.name}
                                        </MenuItem>
                                    ))}
                                </Select> */}
                                            <USelectBox id="storeCd" name="storeCd" items={branchs}
                                                        onItemChange={onParamsChange} defaultValue={select.storeCd}/>
                                        </FormControl>
                                    }
                                    {modify.chkCreate != "" &&
                                        <TextField
                                            fullWidth
                                            size="small"
                                            name="storeNm"
                                            value={modify.storeNm}
                                            disabled
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            onChange={onParamsChange}
                                            variant="outlined"/>
                                    }
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n('기기번호')}</TableCell>
                                <TableCell className="table-cell">
                                    {modify.chkCreate == "" &&
                                        <TextField
                                            fullWidth
                                            size="small"
                                            name="machineNo"
                                            value={modify.machineNo || ""}
                                            required
                                            onChange={onParamsChange}
                                            variant="outlined"/>
                                    }
                                    {modify.chkCreate != "" &&
                                        <TextField
                                            fullWidth
                                            size="small"
                                            name="machineNo"
                                            value={modify.machineNo || ""}
                                            required
                                            disabled
                                            onChange={onParamsChange}
                                            variant="outlined"/>
                                    }
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n('설치일')}</TableCell>
                                <TableCell className="table-cell">
                                    <TextField
                                        type="date"
                                        fullWidth
                                        size="small"
                                        name="installDate"
                                        value={modify.installDate || now}
                                        onChange={onParamsChange}
                                        variant="outlined"
                                        disabled/>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="table-cell-title">{fni18n('일련번호')}</TableCell>
                                <TableCell className="table-cell">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="serialNo"
                                        value={modify.serialNo || ""}
                                        required
                                        onChange={onParamsChange}
                                        variant="outlined"/>
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n('기기IP')}</TableCell>
                                <TableCell className="table-cell">
                                    <FormControl variant="standard"
                                                 sx={{width: "100%", height: "max-content", textAlign: "center", m: 0}}>
                                        <IPut
                                            defaultValue={modify.ip}
                                            onChange={e => onIpChange(e)}/>
                                    </FormControl>
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n('기기PORT')}</TableCell>
                                <TableCell className="table-cell">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="port"
                                        value={modify.port || ""}
                                        required
                                        onChange={onParamsChange}
                                        variant="outlined"/>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="table-cell-title">{fni18n('기종')}</TableCell>
                                <TableCell className="table-cell">
                                    <FormControl size="small" fullWidth>
                                        <Select
                                            name="model"
                                            value={modify.model || "ALL"}
                                            onChange={onParamsChange}
                                        >
                                            {models.map((map) => (
                                                <MenuItem key={map.name} value={map.name}>
                                                    {map.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </TableCell>
                                

                                <TableCell className="table-cell-title">{fni18n('명세표 출력여부')}</TableCell>
                                <TableCell className="table-cell">
                                    <FormControlLabel
                                        sx={{mb: 0, mt: 0}}
                                        control={
                                            <Checkbox
                                                name="rctPrtYn"
                                                checked={modify.rctPrtYn == "N" ? false : true}
                                                onChange={e => onCheckboxChange(e)}
                                            />
                                        }
                                    />
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n('사용여부')}</TableCell>
                                <TableCell className="table-cell">
                                    <FormControlLabel
                                        sx={{mb: 0, mt: 0}}
                                        control={
                                            <Checkbox
                                                name="useYn"
                                                checked={modify.useYn == "N" ? false : true}
                                                onChange={e => onCheckboxChange(e)}
                                            />
                                        }
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="table-cell-title">{fni18n('자동회수방식')}</TableCell>
                                <TableCell className="table-cell">
                                    <FormControlLabel
                                        sx={{mb: 0, mt: 0, }}
                                        control={
                                            <Checkbox
                                                name="autoUnloadOpt"
                                                checked={autoUnloadOpt === "CST"}
                                                onChange={() => handleCheckboxChange("CST")}
                                            />
                                        }
                                        label="CST"
                                    />
                                    <FormControlLabel
                                        sx={{mb: 0, mt: 0}}
                                        control={
                                            <Checkbox
                                                name="autoUnloadOpt"
                                                checked={autoUnloadOpt === "CAM"}
                                                onChange={() => handleCheckboxChange("CAM")}
                                            />
                                        }
                                        label="CAM"
                                    />
                                </TableCell>
                                {/* 수동회수방식 옵션 추가 @2025-03-13 minjlee */}
                                <TableCell className="table-cell-title">{fni18n('수동회수방식')}</TableCell>
                                <TableCell className="table-cell" colSpan={3}>
                                    <FormControlLabel
                                        sx={{mb: 0, mt: 0, fontSize:10}}
                                        control={
                                            <Checkbox
                                            name="manualUnloadOpt"
                                            checked={manualUnloadOpt === "CST"}
                                            onChange={() => handleManualCheckboxChange("CST")}
                                            />
                                        }
                                        label="CST"
                                        labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        sx={{mb: 0, mt: 0}}
                                        control={
                                            <Checkbox
                                            name="manualUnloadOpt"
                                            checked={manualUnloadOpt === "CAM"}
                                            onChange={() => handleManualCheckboxChange("CAM")}
                                            />
                                        }
                                        label="CAM"
                                    />
                                    <FormControlLabel
                                        sx={{mb: 0, mt: 0}}
                                        control={
                                            <Checkbox 
                                                name="manualUnloadOpt"
                                                checked={manualUnloadOpt === "ALL"}
                                                onChange={() => handleManualCheckboxChange("ALL")}
                                            />
                                        }
                                        label="ALL (Both CST and CAM)"
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                            <TableCell className="table-cell-title">{fni18n('설명')}</TableCell>
                            <TableCell className="table-cell" colSpan={3}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    name="description"
                                    value={modify.description || ""}
                                    required
                                    onChange={onParamsChange}
                                    variant="outlined"/>
                            </TableCell>
                            {/* 남시스인터페이스여부 옵션 추가 @2025-10-25 minjlee */}
                            <TableCell className="table-cell-title">{fni18n('액세스키')}</TableCell>
                            <TableCell className="table-cell">
                                <TableCell className="table-cell">
                                    {/* <FormControlLabel
                                    sx={{mb: 0, mt: 0}}
                                    control={
                                        <Checkbox
                                            name="ifYn"
                                            checked={modify.ifYn == "Y"}
                                            onChange={e => onCheckboxChange(e)}
                                            // disabled
                                        />
                                    }
                                    /> */}
                                { 
                                modify.storeCd && modify.machineNo &&
                                    <Button onClick={handleOpen}>{modify.ifYn=='Y'?fni18n('사용'):fni18n('미사용')}</Button>
                                }
                                </TableCell>
                            </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <TableContainer className="table-container">
                    <Table className="table" size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell className="table-cell-title" colSpan={7}>{fni18n('최대 잔량 매수')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="table-cell-title">{fni18n('$100')}</TableCell>
                                <TableCell className="table-cell-title">{fni18n('$50')}</TableCell>
                                <TableCell className="table-cell-title">{fni18n('$20')}</TableCell>
                                <TableCell className="table-cell-title">{fni18n('$10')}</TableCell>
                                <TableCell className="table-cell-title">{fni18n('$5')}</TableCell>
                                <TableCell className="table-cell-title">{fni18n('$1')}</TableCell>
                                <TableCell className="table-cell-title">{fni18n('합계')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="table-cell">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="cnt100D"
                                        value={modify.cnt100D || 0}
                                        type="number"
                                        required
                                        InputProps={{
                                            inputProps: {
                                                min: 0,
                                                style: {textAlign: "center", paddingLeft: 0, paddingRight: 0}
                                            }
                                        }}
                                        onChange={onParamsChange}
                                        variant="outlined"/>
                                </TableCell>
                                <TableCell className="table-cell">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="cnt50D"
                                        value={modify.cnt50D || 0}
                                        type="number"
                                        required
                                        InputProps={{
                                            inputProps: {
                                                min: 0,
                                                style: {textAlign: "center", paddingLeft: 0, paddingRight: 0}
                                            }
                                        }}
                                        onChange={onParamsChange}
                                        variant="outlined"/>
                                </TableCell>
                                <TableCell className="table-cell">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="cnt20D"
                                        value={modify.cnt20D || 0}
                                        type="number"
                                        required
                                        InputProps={{
                                            inputProps: {
                                                min: 0,
                                                style: {textAlign: "center", paddingLeft: 0, paddingRight: 0}
                                            }
                                        }}
                                        onChange={onParamsChange}
                                        variant="outlined"/>
                                </TableCell>
                                <TableCell className="table-cell">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="cnt10D"
                                        value={modify.cnt10D || 0}
                                        type="number"
                                        required
                                        InputProps={{
                                            inputProps: {
                                                min: 0,
                                                style: {textAlign: "center", paddingLeft: 0, paddingRight: 0}
                                            }
                                        }}
                                        onChange={onParamsChange}
                                        variant="outlined"/>
                                </TableCell>
                                <TableCell className="table-cell">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="cnt5D"
                                        value={modify.cnt5D || 0}
                                        type="number"
                                        required
                                        InputProps={{
                                            inputProps: {
                                                min: 0,
                                                style: {textAlign: "center", paddingLeft: 0, paddingRight: 0}
                                            }
                                        }}
                                        onChange={onParamsChange}
                                        variant="outlined"/>
                                </TableCell>
                                <TableCell className="table-cell">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="cnt1D"
                                        value={modify.cnt1D || 0}
                                        type="number"
                                        required
                                        InputProps={{
                                            inputProps: {
                                                min: 0,
                                                style: {textAlign: "center", paddingLeft: 0, paddingRight: 0}
                                            }
                                        }}
                                        onChange={onParamsChange}
                                        variant="outlined"/>
                                </TableCell>
                                <TableCell className="table-cell">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="Dtotal"
                                        value={Dtotal}
                                        disabled
                                        InputProps={{
                                            readOnly: true,
                                            inputProps: {style: {textAlign: "center", paddingLeft: 3, paddingRight: 0}},
                                            // startAdornment:<InputAdornment position="start" sx={{m:0}}>$</InputAdornment>,
                                        }}
                                        onChange={onParamsChange}
                                        variant="outlined"/>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography variant="h6" component="h2">
                            Access Key
                        </Typography>
                        <p id="parent-modal-description">
                            <TextField
                            label="Safe id"
                            name="safeId"
                            value={modify.storeCd +modify.machineNo}
                            onChange={onChange}
                            variant="standard"
                            disabled
                            />
                            {/* <TextField
                            label="Description"
                            name="description"
                            variant="standard"
                            onChange={onChange}
                            value={accessKey.description}
                            /> */}
                            <TextField
                            label="Access Key id"
                            name="accessKeyId"
                            variant="standard"
                            onChange={onChange}
                            value={accessKey.accessKeyId}
                            />
                            <TextField
                            label="Access Key secret"
                            name="accessKeySecret"
                            // type="password"
                            variant="standard"
                            onChange={onChange}
                            value={accessKey.accessKeySecret}
                            />
                        </p>
                        <UButton variant="outlined" onButtonClick={handleClose}>Close</UButton>
                    {
                        modify.ifYn=='Y'?
                        <UAuthButton onButtonClick={handleDelete} menuFrom={location.pathname}>Delete</UAuthButton>
                        :<UAuthButton onButtonClick={handleSave} menuFrom={location.pathname}>Save</UAuthButton>
                    }
                    </Box>
                </Modal>
            </div>
            {/* loading box */}
            <Box sx={{ display: 'flex' }}>
                {loading && <CircularProgress color="inherit" size="3rem"/>}
            </Box>
        </div>
    );
}

export default MachineModify;
